














import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
  name: "LfsCheckBoxFree",
  components: {},
})
export default class LfsSelectBox extends Vue {


  @Prop({
    type: String,
  })
  header!: String;
  @Prop({
    type: [Object, Boolean,String],
  })
  value!: [Object, Boolean,String];
  @Prop({
    type: String,
  })
  label!: String;

  protected check:any = this.value

  @Watch('value')
  changeValue(newValue:any){
    this.check = newValue
  }

}



